import styled from 'styled-components';
import { TREE_DRAG_ANIM_TIME, TREE_DRAG_ANIM_CURVE, TREE_VERTICAL_DASH_OFFSET } from '../../constants.js';
import { jsx } from 'react/jsx-runtime';

var Container = styled.div.withConfig({
  displayName: "VerticalDashes__Container",
  componentId: "sc-hh0hkt-0"
})(function (props) {
  return {
    flex: "0 0 auto",
    height: props.height,
    position: "relative",
    width: props.width * props.hasDescenderByLevel.length,
    transition: props.canAnimate ? "height ".concat(TREE_DRAG_ANIM_TIME, " ").concat(TREE_DRAG_ANIM_CURVE) : void 0
  };
});
var StyledDashes = styled.div.withConfig({
  displayName: "VerticalDashes__StyledDashes",
  componentId: "sc-hh0hkt-1"
})(function (_ref) {
  var isDragOverBottomBar = _ref.isDragOverBottomBar,
    isDragOverTopBar = _ref.isDragOverTopBar,
    isTopHalfOnly = _ref.isTopHalfOnly,
    level = _ref.level,
    theme = _ref.theme,
    width = _ref.width;
  var heightPercentage;
  if (isDragOverTopBar) {
    heightPercentage = isTopHalfOnly ? 75 : 100;
  } else if (isDragOverBottomBar) {
    heightPercentage = isTopHalfOnly ? 25 : 100;
  } else {
    heightPercentage = isTopHalfOnly ? 50 : 100;
  }
  return {
    position: "absolute",
    top: 0,
    insetInlineStart: (level + 1) * width + TREE_VERTICAL_DASH_OFFSET,
    borderInlineStart: "1px dashed ".concat(theme.neutralColors.silver, "}"),
    height: "".concat(heightPercentage, "%"),
    transition: "height ".concat(TREE_DRAG_ANIM_TIME, " ").concat(TREE_DRAG_ANIM_CURVE)
  };
});
var TreeNodeVerticalDashes = function TreeNodeVerticalDashes(props) {
  var verticalDashes = null;
  if (props.hasDescenderByLevel.length > 0) {
    verticalDashes = props.hasDescenderByLevel.map(function (hasDescender, descenderIndex) {
      var isLastDescender = descenderIndex === props.hasDescenderByLevel.length - 1;
      if (!isLastDescender && !hasDescender) {
        return null;
      }
      var isTopHalfOnly = false;
      if (isLastDescender && props.isLastChild) {
        isTopHalfOnly = true;
      }
      return /*#__PURE__*/jsx(StyledDashes, {
        level: descenderIndex,
        width: props.width,
        isTopHalfOnly: isTopHalfOnly,
        isDragOverBottomBar: props.isDragOverBottomBar,
        isDragOverTopBar: props.isDragOverTopBar
      }, descenderIndex);
    });
  }
  return /*#__PURE__*/jsx(Container, {
    canAnimate: props.canAnimate,
    hasDescenderByLevel: props.hasDescenderByLevel,
    height: props.height + (props.isDragOverTopBar || props.isDragOverBottomBar ? props.height : 0),
    width: props.width,
    children: verticalDashes
  });
};

export { TreeNodeVerticalDashes };
